export default "__VITE_ASSET__amI9EIvx__"